// extracted by mini-css-extract-plugin
export var container = "_eu-0";
export var icon = "_eu-1";
export var text = "_eu-2";